var map = {
	"./Logo.svg": "5159",
	"./beach.jpg": "86bf",
	"./garden.jpg": "e699",
	"./home-solid.svg": "54b9",
	"./mountains-water.jpg": "ebc7",
	"./mountains.jpg": "ee28",
	"./my-garden.jpg": "c05b",
	"./paint-garden.jpg": "2529",
	"./painting.jpg": "1331",
	"./portrait.jpg": "ecba",
	"./road-in-forest.jpg": "48ff",
	"./snowy-church.jpg": "f2c1",
	"./studio.jpg": "e619",
	"./tomato-field.jpg": "7f47",
	"./tree-tops.jpg": "ae66",
	"./water-hut.jpg": "748a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";